import { create } from 'zustand';

import type { AuthStoreState } from './auth-store.model';

export const useAuthStore = create<AuthStoreState>((set) => ({
  isAuthenticated: true,
  setIsAuthenticated: (isAuthenticated: boolean) => set({ isAuthenticated }),
  setShowUnauthenticatedToast: (showUnauthenticatedToast: boolean) =>
    set({ showUnauthenticatedToast }),
  showUnauthenticatedToast: false,
}));
